import React, { Component } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import PaystackBtn from "../../components/paystack";
import { startInvoicePayment } from "../../services/invoiceService";
import { getPaystackPublicKey, verifyPayment } from "../../services/paymentService";

function formatMoney(value) {
  const amount = Number(value || 0);
  return Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN" }).format(amount);
}

class InvoicePayModal extends Component {
  state = {
    loading: true,
    payment: null,
    paystackPublicKey: "",
    verifying: false,
  };

  componentDidMount() {
    this.initPayment();
  }

  initPayment = async () => {
    const { invoice } = this.props;
    try {
      this.setState({ loading: true });
      const [payRes, keyRes] = await Promise.all([
        startInvoicePayment(invoice.id),
        getPaystackPublicKey(),
      ]);
      this.setState({
        payment: payRes.data?.data || payRes.data,
        paystackPublicKey: keyRes.data || "",
        loading: false,
      });
    } catch (ex) {
      toast.error(ex.response?.data?.message || "Could not start invoice payment.");
      this.props.onClose();
    }
  };

  handlePaid = async () => {
    const { payment } = this.state;
    if (!payment?.transid) return;

    try {
      this.setState({ verifying: true });
      const response = await verifyPayment({ reference: payment.transid });
      if (response.data?.verified) {
        toast.success("Invoice payment successful.");
        this.props.onPaid();
      } else {
        toast.error(response.data?.message || "Could not verify payment.");
      }
    } catch (ex) {
      toast.error(ex.response?.data?.message || "Payment verification failed.");
    } finally {
      this.setState({ verifying: false });
    }
  };

  render() {
    const { invoice, onClose } = this.props;
    const { loading, payment, paystackPublicKey, verifying } = this.state;

    return (
      <>
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">Pay invoice {invoice.invoicenum}</h5>
                <button type="button" className="close" onClick={onClose} disabled={verifying}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {loading && <p className="mb-0">Preparing payment…</p>}
                {!loading && payment && (
                  <>
                    <p className="text-muted mb-2">
                      Amount due: <strong>{formatMoney(payment.amount)}</strong>
                    </p>
                    <p className="small text-muted mb-3">
                      You will be redirected to Paystack to complete payment securely.
                    </p>
                    {paystackPublicKey ? (
                      <PaystackBtn
                        data={payment}
                        publicKey={paystackPublicKey}
                        onRefresh={this.handlePaid}
                      />
                    ) : (
                      <p className="text-warning mb-0">Online payment is not available. Please contact support.</p>
                    )}
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={verifying}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" onClick={verifying ? undefined : onClose} role="presentation" />
      </>
    );
  }
}

InvoicePayModal.propTypes = {
  invoice: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onPaid: PropTypes.func.isRequired,
};

export default InvoicePayModal;
